import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

export interface XeroConnectedWorkspace {
  uuid: string | null,
  created_at: any | null,
  updated_at: any | null,
  company: number,
  company_name: string,
  tenant_name: string | null,
  tenant_type: string | null
}

export interface Account {
  AccountID: string,
  AddToWatchlist: boolean,
  BankAccountNumber: string,
  BankAccountType: string,
  Class: string,
  Code: string,
  CurrencyCode: string,
  EnablePaymentsToAccount: boolean,
  HasAttachments: boolean,
  Name: string,
  ReportingCode: string,
  ReportingCodeName: string,
  ShowInExpenseClaims: boolean,
  Status: string,
  TaxType: string,
  Type: string,
  UpdatedDateUTC: any
}

export interface WatchedAccount {
  uuid: string,
  created_at: any,
  updated_at: any,
  xero_data: string,
  account_id: string,
  account_name: string,
  external_object: Account
}

export interface XeroIntegrationResponse {
  code?: number | null,
  message: string
}

@Injectable({ providedIn: "root" })
export class XeroIntegrationService {

  constructor(public _http: HttpClient) {}

  getIntegrationStatus(companyId: number): Observable<any> {
    const url = `${environment.apiUrl}/integration/xero/status/${companyId}`;
    return this._http.get(url);
  }

  getConnectedWorkspaces(): Observable<any> {
    const url = `${environment.apiUrl}/integration/xero/connected-workspaces`;
    return this._http.get(url);
  }

  refreshBankTransactions(companyId: number): Observable<any> {
    const url = `${environment.apiUrl}/integration/xero/bank-transactions/${companyId}`;
    return this._http.get(url);
  }

  getAvailableAccountsByCompany(companyId: number): Observable<any> {
    const url = `${environment.apiUrl}/integration/xero/company/available-accounts/${companyId}`;
    return this._http.get(url);
  }

  getAvailableAccounts(connectionUuid: string): Observable<any> {
    const url = `${environment.apiUrl}/integration/xero/available-accounts/${connectionUuid}`;
    return this._http.get(url);

  }

  getCompanyAccounts(connectionUuid: string): Observable<any> {
    const url = `${environment.apiUrl}/integration/xero/manage-accounts/${connectionUuid}`;
    return this._http.get(url);
  }

  addAccountToCompany(connectionUuid: string, account: Account): Observable<any> {
    const url = `${environment.apiUrl}/integration/xero/manage-accounts/${connectionUuid}`;
    return this._http.post(url, account);
  }

  removeAccountFromCompany(watchedAccountUuid: string): Observable<any> {
    const url = `${environment.apiUrl}/integration/xero/manage-accounts/${watchedAccountUuid}`;
    return this._http.delete(url);
  }

  disconnectWorkspace(connectionUuid: string): Observable<any> {
    const url = `${environment.apiUrl}/integration/xero/workspace/disconnect/${connectionUuid}`;
    return this._http.delete(url);
  }
}
